var exports = {
  "W": "xe533113f--c596cd--skeleton-filters",
};

module.exports = exports;
